globalThis.PlayerUpdate = class PlayerUpdate {
  static from(player) {
    const update = Object.create(null);
    update.u = player.uid;
    update.i = player.index;
    update.x = player.position.x;
    update.y = player.position.y;
    update.d = player.direction;
    update.s = player.sprinting + 0;
    update.m = player.moving + 0;
    update.g = player.grounded + 0;
    update.f = player.floating + 0;
    return update;
  }

  apply(player) {
    player.uid = this.u;
    player.index = this.i;
    player.position.x = this.x;
    player.position.y = this.y;
    player.direction = this.d;
    player.sprinting = !!this.s;
    player.moving = !!this.m;
    player.grounded = !!this.g;
    player.floating = !!this.f;
  }
};
